// extracted by mini-css-extract-plugin
export var container = "index-module--container--19cOX";
export var successClass = "index-module--successClass--3v_iH";
export var content = "index-module--content--fmgyh";
export var buttonClass = "index-module--buttonClass--1RppZ";
export var pairClass = "index-module--pairClass--3FiBK";